import api from './api';

// Admin API endpoints
export const adminAPI = {
  // ==================== Users ====================
  users: {
    getAll: async () => {
      const response = await api.get('/admin/users');
      return response.data;
    },
    create: async (data) => {
      const response = await api.post('/admin/users', data);
      return response.data;
    },
    update: async (id, data) => {
      const response = await api.put(`/admin/users/${id}`, data);
      return response.data;
    },
    delete: async (id) => {
      const response = await api.delete(`/admin/users/${id}`);
      return response.data;
    },
    getCompanies: async (userId) => {
      const response = await api.get(`/admin/users/${userId}/companies`);
      return response.data;
    },
    updateCompanies: async (userId, companyIds) => {
      const response = await api.put(`/admin/users/${userId}/companies`, { companyIds });
      return response.data;
    },
    setActive: async (userId, isActive) => {
      const response = await api.put(`/admin/users/${userId}/status`, { isActive });
      return response.data;
    },
    // Their sessions end, and they set up two-step verification again at their next sign-in.
    resetTwoFactor: async (userId) => (await api.post(`/admin/users/${userId}/reset-2fa`)).data,
    updateRole: async (userId, role) => {
      const response = await api.put(`/admin/users/${userId}/role`, { role });
      return response.data;
    },
    getDashboards: async (userId) => {
      const response = await api.get(`/admin/users/${userId}/dashboards`);
      return response.data;
    },
    updateDashboards: async (userId, dashboardIds) => {
      const response = await api.put(`/admin/users/${userId}/dashboards`, { dashboardIds });
      return response.data;
    },
  },

  // ==================== API Keys ====================
  apiKeys: {
    getAll: async () => {
      const response = await api.get('/admin/api-keys');
      return response.data;
    },
    create: async (data) => {
      const response = await api.post('/admin/api-keys', data);
      return response.data;
    },
    update: async () => {
      // API keys don't support update, but required for CRUD interface
      throw new Error('API keys cannot be updated');
    },
    delete: async (id) => {
      const response = await api.delete(`/admin/api-keys/${id}`);
      return response.data;
    },
    toggle: async (id) => {
      const response = await api.put(`/admin/api-keys/${id}/toggle`);
      return response.data;
    },
  },

  // ==================== Metric Definitions ====================
  metricDefinitions: {
    getAll: async () => {
      const response = await api.get('/admin/metrics/definitions');
      return response.data;
    },
    create: async (data) => {
      const response = await api.post('/admin/metrics/definitions', data);
      return response.data;
    },
    update: async (id, data) => {
      const response = await api.put(`/admin/metrics/definitions/${id}`, data);
      return response.data;
    },
    delete: async (id) => {
      const response = await api.delete(`/admin/metrics/definitions/${id}`);
      return response.data;
    },
  },
};

export default adminAPI;
